import { Related, ResourceBase } from '../../resource-types';
import { RawModel } from '../schema';

export type GenerationStatus =
  | 'pending'
  | 'processing'
  | 'completed'
  | 'failed';

export const ASPECT_RATIOS = [
  '21x9',
  '16x9',
  '4x3',
  '1x1',
  '3x4',
  '9x16',
  '9x21'
] as const;

export interface Generation extends ResourceBase {
  status: GenerationStatus;
  aspect_ratio: string;
  prompt: string;
  width: number;
  height: number;
  reference_base64: string;
  /** URL to the generated content */
  url: string;
  /** Seed for generation: a value (often a string of numbers and letters) that acts as a starting point for creating the world or other content */
  seed: number;
  relationships: {
    model: Related<'generative-model'>;
    reference_assets: Related<'asset'>[];
    workspace: Related<'workspace'>;
    reference_generation: Related<'generation'>;
  };
}

export const generation: RawModel = {
  type: 'generation',
  plural: 'generations',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    created_at: 'date',
    height: 'number',
    prompt: 'string',
    seed: 'number',
    status: 'completed',
    updated_at: 'date',
    url: 'string',
    width: 'number'
  },
  relationships: {
    workspace: {
      type: 'workspace',
      binding: ['one', 'many'],
      reverse: 'generation'
    },
    reference_assets: {
      type: 'asset',
      binding: ['one', 'many'],
      reverse: 'generation'
    },
    reference_generation: {
      type: 'generation',
      binding: ['one', 'one'],
      reverse: 'generation'
    },
    model: {
      type: 'generative-model',
      binding: ['one', 'many'],
      reverse: 'generation'
    }
  }
};
